import { render, staticRenderFns } from "./HistoryItemTypeDelivery.vue?vue&type=template&id=6b966b2d&scoped=true&"
import script from "./HistoryItemTypeDelivery.vue?vue&type=script&lang=js&"
export * from "./HistoryItemTypeDelivery.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItemTypeDelivery.vue?vue&type=style&index=0&id=6b966b2d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b966b2d",
  null
  
)

export default component.exports